export function sortAlphaNumeric(options) {
	options.sort((a, b) => {
		return a.label.localeCompare(b.label);
	});
}
